import { useBasicABTest } from '@bridebook/web/app-basic/lib/ab-tests/hooks/use-basic-ab-test';
import { getTestVariant } from '@bridebook/web/app-basic/lib/ab-tests/selectors';
import type { BasicStore } from '@bridebook/web/app-basic/lib/types';

export const showroundsLoggedOutUsersTestId = 'LIVE-28500_ShowroundsLoggedOutUsers';

export const useABTest_ShowroundsLoggedOutUsers = () =>
  useBasicABTest(showroundsLoggedOutUsersTestId);

export const getVariant_ShowroundsLoggedOutUsers = (state: BasicStore) =>
  getTestVariant(state, showroundsLoggedOutUsersTestId);

export const useIsShowroundsLoggedOutUsers_LIVE28500_Enabled = () => {
  const { variant } = useABTest_ShowroundsLoggedOutUsers();
  return variant === '1';
};
